import { useEditorState, type Editor } from '@tiptap/react';
import { HTMLAttributes } from 'react';

import { cn } from '../../../utils/cn';

interface CharacterCountProps extends Pick<HTMLAttributes<HTMLParagraphElement>, 'className'> {
  editor: Editor;
  hasEmoji?: boolean;
  hasWords?: boolean;
}

export function CharacterCount({
  className,
  editor,
  hasEmoji = false,
  hasWords = false,
}: CharacterCountProps) {
  const { charactersCount, wordsCount } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      charactersCount: editor.storage.characterCount?.characters?.() ?? 0,
      wordsCount: editor.storage.characterCount?.words?.() ?? 0,
    }),
  });

  return (
    <p className={cn('px-4 pb-2 text-end text-sm text-muted-foreground', className)}>
      {charactersCount} {charactersCount === 1 ? 'carácter' : 'caracteres'}
      {hasWords ? (
        <>
          <span className="mx-1">|</span>
          {wordsCount} palabra{wordsCount === 1 ? '' : 's'}
        </>
      ) : null}
      {hasEmoji ? (
        <span aria-label="emoji" className="ml-2" role="img">
          {wordsCount <= 0
            ? '🙂'
            : wordsCount <= 100
              ? '🤩'
              : wordsCount <= 200
                ? '🤓'
                : wordsCount <= 300
                  ? '😮'
                  : wordsCount <= 400
                    ? '😱'
                    : '🥶'}
        </span>
      ) : null}
    </p>
  );
}
